import type { CrmClient } from '../api'

type ClientNameLike = Pick<CrmClient, 'unified_client_id' | 'preferred_name' | 'client_type'> & {
  nickname?: string | null
}

export function getClientBaseName(client: Partial<ClientNameLike> | null | undefined, fallback = 'Unnamed contact'): string {
  const name = String(client?.preferred_name ?? '').trim()
  if (name) return name
  const id = String(client?.unified_client_id ?? '').trim()
  return id ? `${fallback} ${id}` : fallback
}

export function getClientDisplayName(client: Partial<ClientNameLike> | null | undefined, fallback = 'Unnamed contact'): string {
  const baseName = getClientBaseName(client, fallback)
  const nickname = String(client?.nickname ?? '').trim()
  if (!nickname || client?.client_type === 'organization') return baseName

  const parts = baseName.split(/\s+/).filter(Boolean)
  if (parts.length < 2) return nickname
  return [nickname, ...parts.slice(1)].join(' ')
}

export function getClientInitial(client: Partial<ClientNameLike> | null | undefined): string {
  const label = getClientDisplayName(client)
  const first = label.match(/[A-Za-z0-9]/)?.[0]
  return (first || '?').toUpperCase()
}
